export const EXCEL_FILE_ACCEPTED_EXTENSIONS = [".xlsx", ".xls"];
export const EXCEL_FILE_ACCEPTED_MIME_TYPES = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
];
export const EXCEL_FILE_MAX_SIZE = 1024 * 1024 * 10; // 10 MB

export const TABLE_HOURS_COUNT = 24;

export const EXCEL_REQUIRED_COLUMNS = 2;
export const EXCEL_REQUIRED_TOTAL_ROWS = 25;
export const EXCEL_SUMMARY_REQUIRED_TOTAL_ROWS = 24 * 365 + 1;
